export default IconHttpPut => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-http-put" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M3 12h2a2 2 0 1 0 0 -4h-2v8" />
  <path d="M17 8h4" />
  <path d="M19 8v8" />
  <path d="M10 8v6a2 2 0 1 0 4 0v-6" />
</svg>`;